import { useId } from "react";
import { classNames } from "../../helpers/classNames";

/**
 * A native checkbox in brand rose with its label beside it. The whole row is
 * the tap target (44px minimum), the label can hold links.
 */
const Checkbox = ({ id, checked, onChange, children, disabled = false, className, ...rest }) => {
  const autoId = useId();
  const boxId = id || `check-${autoId}`;
  return (
    <label
      htmlFor={boxId}
      className={classNames(
        "flex items-start gap-3 min-h-[44px] text-[13px] md:text-sm leading-snug text-md-muted cursor-pointer",
        disabled && "opacity-60 cursor-not-allowed",
        className
      )}
    >
      <input
        id={boxId}
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className="mt-px h-[22px] w-[22px] flex-shrink-0 rounded border-md-control-input text-md-pink-dark focus:ring-md-pink focus:ring-offset-0"
        style={{ accentColor: "#9E4D5F" }}
        {...rest}
      />
      <span className="pt-0.5">{children}</span>
    </label>
  );
};

export default Checkbox;
